export default __webpack_public_path__ + "static/media/gallery-wip-handle_04.2cf8ef2e.jpg";